var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Datepicker',{style:(_vm.customStyles),attrs:{"lang":"es","inputClass":"filter-datepicker","placeholder":_vm.label,"range":"","showClearButton":"","disabled-end-date":{ from: new Date(), to: null },"value":_vm.value},on:{"input":_vm.onChange,"reset":function($event){return _vm.$emit('reset')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }